module.exports = __webpack_public_path__ + "media/images/signatures/2024/sara-891d29d8b2319875771a2e15abc1dc7e.png";